import { Avatar, Backdrop, Box, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useMemo } from "react";

import getConst from "api/common/getConst";
import lang from "lang";

interface ILoaderContentProps {
    children?: ReactNode;
    text?: string;
    animate?: boolean;
    isNotAbsolutePosition?: boolean;
}
interface ILoaderProps extends ILoaderContentProps {
    isLoading?: boolean;
    zIndex?: number;
    fullScreen?: boolean;
}
export default function Loader({
    isLoading = true,
    fullScreen = true,
    zIndex,
    ...props
}: ILoaderProps) {
    if (fullScreen) {
        return (
            <Backdrop
                sx={[
                    {
                        color: "#fff",
                    },
                    zIndex
                        ? {
                              zIndex,
                          }
                        : {
                              zIndex: (theme) => theme.zIndex.drawer + 1,
                          },
                ]}
                open={isLoading}
            >
                <LoaderContent
                    {...props}
                    isNotAbsolutePosition={fullScreen}
                />
            </Backdrop>
        );
    }
    if (!isLoading) {
        return null;
    }
    return <LoaderContent {...props} />;
}
export const LoaderContent = ({
    animate = true,
    text = "",
    children = undefined,
    isNotAbsolutePosition = false,
}: ILoaderContentProps) => {
    const sxProps = useMemo(() => {
        if (!isNotAbsolutePosition) {
            return { position: "absolute", left: 0, top: 0, right: 0, bottom: 0 };
        }
        return {};
    }, [isNotAbsolutePosition]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                ...sxProps,
            }}
        >
            {children ? (
                children
            ) : (
                <>
                    <Avatar
                        src={
                            getConst("assets-images-path") +
                            (animate ? "cm_logo_animated.svg" : "cm_logo.svg")
                        }
                        variant="square"
                        sx={{
                            width: 200,
                            height: 200,
                            bgcolor: "transparent",
                        }}
                    />
                    <Typography>{text ? text : lang.components.loader.defaultText}</Typography>
                </>
            )}
        </Box>
    );
};
